import React from 'react';
import { useNavigate, useSearchParams, Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Alert, Button, Paper, Container } from '@mui/material';
import { useI18n } from '../i18n';

export default function AuthError() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t } = useI18n();
  const raw = searchParams.get('message') || '인증에 실패했습니다.';
  let message = raw;
  try {
    message = decodeURIComponent(raw);
  } catch {
    message = raw;
  }

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 3, md: 6 } }}>
      <Paper elevation={0} variant="outlined" sx={{ p: { xs: 3, md: 4 }, textAlign: 'center', borderRadius: 3 }}>
        <Typography variant="h5" component="h1" gutterBottom fontWeight={700}>
          {t('authError.title')}
        </Typography>
        <Alert severity="error" sx={{ my: 3, textAlign: 'left' }}>
          {message}
        </Alert>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {t('authError.hint')}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Button variant="contained" size="large" component={RouterLink} to="/auth">
            {t('authError.retry')}
          </Button>
          <Button variant="outlined" size="large" component={RouterLink} to="/guide">
            {t('authError.guide')}
          </Button>
          <Button variant="text" onClick={() => navigate('/')}>
            {t('authError.home')}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
